export const translations = {
  it: {
    // Header/Navigation
    nav: {
      home: 'Home',
      book: 'Prenota',
      about: 'Le Casette',
      services: 'Servizi',
      events: 'Eventi',
      contact: 'Contatti',
      login: 'Accedi',
      myBooking: 'La Mia Prenotazione',
      logout: 'Esci'
    },
    
    // Home Page
    home: {
      welcome: 'Benvenuti a',
      title: 'La Maisonette di Paestum',
      subtitle: 'Un angolo di paradiso tra i templi e il mare',
      description: 'Casette accoglienti immerse nella natura, a pochi passi dai templi di Paestum e dalle spiagge del Cilento.',
      bookNow: 'Prenota Ora',
      discover: 'Scopri di più',
      ourCasette: 'Le Nostre Casette',
      casetteDesc: 'Alloggi unici con vista sui templi',
      whyChooseUs: 'Perché Sceglierci',
      location: 'Posizione Strategica',
      locationDesc: 'A 5 minuti dai Templi di Paestum e 10 minuti dal mare',
      comfort: 'Comfort e Relax',
      comfortDesc: 'Casette dotate di ogni comfort per un soggiorno indimenticabile',
      nature: 'Immersi nella Natura',
      natureDesc: 'Giardino con ulivi, aranci e profumi mediterranei',
      hospitality: 'Ospitalità Autentica',
      hospitalityDesc: 'Accoglienza familiare e consigli per scoprire il territorio'
    },
    
    // Booking Page
    booking: {
      title: 'Prenota il Tuo Soggiorno',
      selectCasetta: 'Seleziona Casetta',
      checkIn: 'Data Arrivo',
      checkOut: 'Data Partenza',
      guests: 'Ospiti',
      guest: 'ospite',
      guestsPlural: 'ospiti',
      nights: 'notti',
      night: 'notte',
      totalPrice: 'Prezzo Totale',
      perNight: 'a notte',
      bookNow: 'Prenota Ora',
      checkAvailability: 'Verifica Disponibilità',
      available: 'Disponibile',
      notAvailable: 'Non Disponibile',
      yourDetails: 'I Tuoi Dati',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      notes: 'Note (opzionale)',
      notesPlaceholder: 'Richieste speciali, orario arrivo...',
      confirmBooking: 'Conferma Prenotazione',
      bookingSuccess: 'Prenotazione Confermata!',
      bookingCode: 'Il tuo codice prenotazione è',
      maxGuests: 'Max',
      from: 'Da',
      selectDates: 'Seleziona le date',
      adultsChildren: 'Adulti e bambini'
    },
    
    // About/Casette Page
    about: {
      title: 'Le Nostre Casette',
      subtitle: 'Scopri i nostri alloggi unici',
      description: 'Ogni casetta è stata progettata per offrire comfort e autenticità, con materiali naturali e vista sui templi.',
      features: 'Caratteristiche',
      amenities: 'Servizi Inclusi',
      gallery: 'Galleria',
      bookThis: 'Prenota questa casetta',
      maxCapacity: 'Capacità massima',
      size: 'Dimensioni',
      beds: 'Posti letto',
      bathroom: 'Bagno',
      kitchen: 'Cucina',
      airConditioning: 'Aria condizionata',
      wifi: 'WiFi gratuito',
      parking: 'Parcheggio',
      garden: 'Giardino'
    },
    
    // Login Page  
    login: {
      title: 'Accedi',
      subtitle: 'Accedi per gestire la tua prenotazione',
      email: 'Email',
      password: 'Password',
      loginButton: 'Accedi',
      orUseCode: 'Oppure usa il codice prenotazione',
      bookingCode: 'Codice Prenotazione',
      accessWithCode: 'Accedi con Codice',
      noAccount: 'Non hai un account?',
      register: 'Registrati',
      forgotPassword: 'Password dimenticata?'
    },
    
    // Dashboard
    dashboard: {
      welcome: 'Bentornato',
      yourBooking: 'La Tua Prenotazione',
      bookingDetails: 'Dettagli Prenotazione',
      checkIn: 'Check-in',
      checkOut: 'Check-out', 
      guests: 'Ospiti',
      status: 'Stato',
      confirmed: 'Confermata',
      pending: 'In attesa',
      cancelled: 'Cancellata',
      onlineCheckin: 'Check-in Online',
      completeCheckin: 'Completa il check-in online',
      houseRules: 'Regolamento',
      viewRules: 'Visualizza il regolamento',
      services: 'Servizi Extra',
      exploreServices: 'Esplora i servizi disponibili',
      needHelp: 'Hai bisogno di aiuto?',
      contactUs: 'Contattaci'
    },
    
    // Services
    services: {
      title: 'Servizi',
      subtitle: 'Rendi il tuo soggiorno speciale',
      breakfast: 'Colazione',
      breakfastDesc: 'Colazione con prodotti locali',
      transfer: 'Transfer',
      transferDesc: 'Servizio transfer da/per aeroporto',
      tours: 'Escursioni',
      toursDesc: 'Tour guidati nel Cilento',
      bike: 'Noleggio Bici',
      bikeDesc: 'Esplora il territorio in bicicletta',
      request: 'Richiedi',
      addToBooking: 'Aggiungi alla prenotazione'
    },
    
    // Common
    common: {
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      save: 'Salva',
      cancel: 'Annulla',
      close: 'Chiudi',
      back: 'Indietro',
      next: 'Avanti',
      submit: 'Invia',
      required: 'Campo obbligatorio',
      optional: 'opzionale',
      yes: 'Sì',
      no: 'No',
      or: 'oppure',
      and: 'e',
      from: 'da',
      to: 'a',
      price: 'Prezzo',
      total: 'Totale',
      date: 'Data',
      time: 'Ora',
      phone: 'Telefono',
      email: 'Email',
      address: 'Indirizzo',
      selectLanguage: 'Seleziona lingua'
    },
    
    // Footer
    footer: {
      address: 'Via dei Templi, Paestum (SA)',
      followUs: 'Seguici',
      quickLinks: 'Link Utili',
      privacyPolicy: 'Privacy Policy',
      terms: 'Termini e Condizioni',
      cookies: 'Cookie Policy',
      allRights: 'Tutti i diritti riservati'
    }
  },
  
  en: {
    // Header/Navigation
    nav: {
      home: 'Home',
      book: 'Book',
      about: 'The Cottages',
      services: 'Services',
      events: 'Events',
      contact: 'Contact',
      login: 'Login',
      myBooking: 'My Booking',
      logout: 'Logout'
    },
    
    // Home Page
    home: {
      welcome: 'Welcome to',
      title: 'La Maisonette di Paestum',
      subtitle: 'A corner of paradise between temples and sea',
      description: 'Cozy cottages surrounded by nature, steps away from the Paestum temples and the Cilento beaches.',
      bookNow: 'Book Now',
      discover: 'Discover More',
      ourCasette: 'Our Cottages',
      casetteDesc: 'Unique accommodations with temple views',
      whyChooseUs: 'Why Choose Us',
      location: 'Strategic Location',
      locationDesc: '5 minutes from Paestum Temples and 10 minutes from the beach',
      comfort: 'Comfort & Relaxation',
      comfortDesc: 'Cottages with all amenities for an unforgettable stay',
      nature: 'Immersed in Nature',
      natureDesc: 'Garden with olive trees, oranges and Mediterranean scents',
      hospitality: 'Authentic Hospitality',
      hospitalityDesc: 'Family welcome and tips to discover the area'
    },
    
    // Booking Page
    booking: {
      title: 'Book Your Stay',
      selectCasetta: 'Select Cottage',
      checkIn: 'Check-in Date',
      checkOut: 'Check-out Date',
      guests: 'Guests',
      guest: 'guest',
      guestsPlural: 'guests',
      nights: 'nights',
      night: 'night',
      totalPrice: 'Total Price',
      perNight: 'per night',
      bookNow: 'Book Now',
      checkAvailability: 'Check Availability',
      available: 'Available',
      notAvailable: 'Not Available',
      yourDetails: 'Your Details',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Special requests, arrival time...',
      confirmBooking: 'Confirm Booking',
      bookingSuccess: 'Booking Confirmed!',
      bookingCode: 'Your booking code is',
      maxGuests: 'Max',
      from: 'From',
      selectDates: 'Select dates',
      adultsChildren: 'Adults and children'
    },
    
    // About/Casette Page
    about: {
      title: 'Our Cottages',
      subtitle: 'Discover our unique accommodations',
      description: 'Each cottage was designed to offer comfort and authenticity, with natural materials and temple views.',
      features: 'Features',
      amenities: 'Included Amenities',
      gallery: 'Gallery',
      bookThis: 'Book this cottage',
      maxCapacity: 'Maximum capacity',
      size: 'Size',
      beds: 'Beds',
      bathroom: 'Bathroom',
      kitchen: 'Kitchen',
      airConditioning: 'Air conditioning',
      wifi: 'Free WiFi',
      parking: 'Parking',
      garden: 'Garden'
    },
    
    // Login Page  
    login: {
      title: 'Login',
      subtitle: 'Login to manage your booking',
      email: 'Email',
      password: 'Password',
      loginButton: 'Login',
      orUseCode: 'Or use booking code',
      bookingCode: 'Booking Code',
      accessWithCode: 'Access with Code',
      noAccount: "Don't have an account?",
      register: 'Register',
      forgotPassword: 'Forgot password?'
    },
    
    // Dashboard
    dashboard: {
      welcome: 'Welcome back',
      yourBooking: 'Your Booking',
      bookingDetails: 'Booking Details',
      checkIn: 'Check-in',
      checkOut: 'Check-out', 
      guests: 'Guests',
      status: 'Status',
      confirmed: 'Confirmed',
      pending: 'Pending',
      cancelled: 'Cancelled',
      onlineCheckin: 'Online Check-in',
      completeCheckin: 'Complete online check-in',
      houseRules: 'House Rules',
      viewRules: 'View house rules',
      services: 'Extra Services',
      exploreServices: 'Explore available services',
      needHelp: 'Need help?',
      contactUs: 'Contact Us'
    },
    
    // Services
    services: {
      title: 'Services',
      subtitle: 'Make your stay special',
      breakfast: 'Breakfast',
      breakfastDesc: 'Breakfast with local products',
      transfer: 'Transfer',
      transferDesc: 'Airport transfer service',
      tours: 'Tours',
      toursDesc: 'Guided tours in Cilento',
      bike: 'Bike Rental',
      bikeDesc: 'Explore the area by bicycle',
      request: 'Request',
      addToBooking: 'Add to booking'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      required: 'Required field',
      optional: 'optional',
      yes: 'Yes',
      no: 'No',
      or: 'or',
      and: 'and',
      from: 'from',
      to: 'to',
      price: 'Price',
      total: 'Total',
      date: 'Date',
      time: 'Time',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      selectLanguage: 'Select language'
    },
    
    // Footer
    footer: {
      address: 'Via dei Templi, Paestum (SA), Italy',
      followUs: 'Follow Us',
      quickLinks: 'Quick Links',
      privacyPolicy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      cookies: 'Cookie Policy',
      allRights: 'All rights reserved'
    }
  }
};
